import api from './http'

/* *****뉴스룸-보도자료 FRONT API***** */

// 함께가치 목록 조회
const getWriting = (data = null, callback, errorHandler) => {
  return api.getPromise('GET', '/api/writing', data)
}

// 함께가치 상세 조회
const getWritingDetail = (writingSeq, options, callback, errorHandler) => {
  return api.getPromise('GET', `/api/writing/${writingSeq}/detail`, options)
}

// 함께가치 링크 공유 상세 조회
const getWritingLink = (data = null, callback, errorHandler) => {
  return api.getPromise('GET', '/api/writing/detail', data)
}

// 함께가치 카테고리 조회
const getWritingCategory = (data = null, callback, errorHandler) => {
  return api.getPromise('GET', '/api/writing/category/get')
}

export default {
  getWriting,
  getWritingDetail,
  getWritingLink,
  getWritingCategory
}
